import { DashboardView } from "../views/DashboardView";

export const isAITabActive = (view: DashboardView) =>
    [
        DashboardView.AI_SETTINGS_GENERAL,
        DashboardView.AI_SETTINGS_MODEL_CONFIGURATION,
        DashboardView.AI_SETTINGS_TESTING,
    ].includes(view);

export const isReportsTabActive = (view: DashboardView) =>
    [
        DashboardView.REPORTS_EFFICIENCY,
        DashboardView.REPORTS_SERVICE_LEVEL_TAG_GROUPS,
        DashboardView.REPORTS_SERVICE_LEVEL_TAGS,
        DashboardView.REPORTS_BACK_LINE_TAGS,
        DashboardView.REPORTS_ADVISER_GROUPS,
        DashboardView.REPORTS_ADVISER_TAG_GROUPS,
        DashboardView.REPORTS_OTHER,
    ].includes(view);
